import { useQuery } from '@tanstack/react-query';

import { axiosPrivate } from 'app/utils';

export interface GlobalSectionType {
  id: string;
  displayName: string;
  version: number;
}

interface GlobalSectionTypesResponse {
  sectionTypes: GlobalSectionType[];
}

async function fetchGlobalSectionTypes(organisationId: string) {
  const { data } = await axiosPrivate.get<GlobalSectionTypesResponse>('/v3/pharmacist/section-types', {
    params: { scope: 'global', organisationId },
  });
  return data;
}

export function useGetGlobalSectionTypes(organisationId: string) {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['section-types', 'global', organisationId],
    queryFn: () => fetchGlobalSectionTypes(organisationId),
    enabled: Boolean(organisationId),
    meta: { errorMessage: 'Failed to load section types' },
  });

  return {
    sectionTypes: data?.sectionTypes ?? [],
    isLoading,
    isError,
    error,
  };
}
